var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "unitDetails" } },
    [
      _c(
        "div",
        { ref: "scrollArea", staticClass: "section-content" },
        [
          _vm.selected
            ? [
                _c("div", { staticClass: "vo-card" }, [
                  _c("div", { staticClass: "vo-header" }, [
                    _vm._v("\n          Unit Details\n        ")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "vo-content" }, [
                    _c("div", { staticClass: "details" }, [
                      _c("div", { staticClass: "vo-s-list" }, [
                        _c("div", { staticClass: "name" }, [_vm._v("Unit #")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.unit.title))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "vo-s-list" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v("Property")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            class: {
                              selectable: this.hasPermissions(["property"])
                            },
                            on: {
                              click: function($event) {
                                _vm.openProperty(_vm.unit.property)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.property.name))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "vo-s-list" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v("Unit Type")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.unitType.name))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "vo-s-list" }, [
                        _c("div", { staticClass: "name" }, [_vm._v("Address")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm.unit.address
                            ? _c("div", [
                                _c("div", [
                                  _vm.unit.address.line2
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.unit.address.line2) + " - "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(_vm._s(_vm.unit.address.line1))
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(_vm.unit.address.city) +
                                      ", " +
                                      _vm._s(_vm.unit.address.province) +
                                      " " +
                                      _vm._s(_vm.unit.address.country)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(_vm._s(_vm.unit.address.postal))
                                ])
                              ])
                            : _vm.property.address
                              ? _c("div", [
                                  _c("div", [
                                    _vm.property.address.line2
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.property.address.line2) +
                                              " - "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(_vm._s(_vm.property.address.line1))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.property.address.city) +
                                        ", " +
                                        _vm._s(_vm.property.address.province) +
                                        " " +
                                        _vm._s(_vm.property.address.country)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.property.address.postal))
                                  ])
                                ])
                              : _vm._e()
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "clear" })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "vo-footer" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "vo-button",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              _vm.routeAddQueries({
                                dialog: "unit-manage",
                                dialogAction: "edit"
                              })
                            }
                          }
                        },
                        [
                          _c("v-icon", [_vm._v("mdi-pencil")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("Edit")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "vo-button red",
                          attrs: { flat: "" },
                          on: { click: _vm.deleteUnitDialog }
                        },
                        [
                          _c("v-icon", [_vm._v("mdi-delete")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("Delete")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.hasPermissions(["user"], this.unit.property)
                  ? _c("div", { staticClass: "vo-card" }, [
                      _c("div", { staticClass: "vo-header" }, [
                        _vm._v("\n          Unit Roles\n          "),
                        _c(
                          "div",
                          { staticClass: "vo-actions" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "vo-icon-button",
                                attrs: { flat: "", fab: "", small: "" },
                                on: { click: _vm.openInvite }
                              },
                              [
                                _c("v-icon", { attrs: { medium: "" } }, [
                                  _vm._v("mdi-plus")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm.app.pages.units.unitRoles.list
                            ? _c("vo-list", {
                                staticClass: "list",
                                attrs: {
                                  list: _vm.app.pages.units.unitRoles.list
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "itemSlot",
                                    fn: function(item) {
                                      return _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "ripple",
                                              rawName: "v-ripple"
                                            }
                                          ],
                                          staticClass: "user-role",
                                          on: {
                                            click: function($event) {
                                              _vm.openUser(item.item)
                                            }
                                          }
                                        },
                                        [
                                          _c("vo-avatar", {
                                            staticClass: "avatar",
                                            attrs: {
                                              size: 32,
                                              user: _vm.$store.getters.user(
                                                item.item
                                              )
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "text" }, [
                                            _c("div", { staticClass: "name" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$store.getters.user(
                                                    item.item
                                                  ).fullName
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "email" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$store.getters.user(
                                                      item.item
                                                    ).email
                                                  )
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "icon" }, [
                                            _c("i", {
                                              staticClass:
                                                "mdi mdi-24px mdi-chevron-right"
                                            })
                                          ])
                                        ],
                                        1
                                      )
                                    }
                                  }
                                ])
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasPermissions(
                  ["ticket", "ticketAdmin", "ticketManager"],
                  this.unit.property
                )
                  ? _c("div", { staticClass: "vo-card" }, [
                      _c("div", { staticClass: "vo-header" }, [
                        _vm._v("\n          Unit Tickets\n          "),
                        _c(
                          "div",
                          { staticClass: "vo-actions" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "vo-icon-button",
                                attrs: { flat: "", fab: "", small: "" },
                                on: { click: _vm.openTicketCreate }
                              },
                              [
                                _c("v-icon", { attrs: { medium: "" } }, [
                                  _vm._v("mdi-plus")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm.app.pages.units.unitTickets.list
                            ? _c("vo-list", {
                                staticClass: "list",
                                attrs: {
                                  list: _vm.app.pages.units.unitTickets.list,
                                  itemComponent: "vo-ticket-list",
                                  selectable: ""
                                },
                                on: { itemSelected: _vm.openTicket }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ]
            : [_c("vo-empty-state", { attrs: { text: "SELECT A UNIT" } })]
        ],
        2
      ),
      _vm._v(" "),
      _c("vo-details-header")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b53b31e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b53b31e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UnitDetails.vue
// module id = 629
// module chunks = 4